<div class="input-block {{panelClass}}">
    <label>{{label}} </label>
    <input type="text" class="form-control" [formControl]="inputControl" (input)="onInputChange()" />
    <small [hidden]="inputControl.valid || inputControl.untouched" class="text-danger">
        This field is required.
    </small>
</div>